import { render, staticRenderFns } from "./AppCardSearch.vue?vue&type=template&id=5871a9c3&scoped=true"
import script from "./AppCardSearch.vue?vue&type=script&lang=js"
export * from "./AppCardSearch.vue?vue&type=script&lang=js"
import style0 from "./AppCardSearch.vue?vue&type=style&index=0&id=5871a9c3&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5871a9c3",
  null
  
)

export default component.exports